module.exports = __webpack_public_path__ + "img/SES_1150254100.52e72ee5.jpg";